// Gallery.jsx
import { Button, ButtonGroup } from "react-bootstrap";
import { header } from "./globalVariables";
import { api } from "./pureFunctions";
import { useDropboxImages } from "./useDropboxImages";
import { useState, useCallback, useEffect } from "react";

import arrowIcon from "./img/arrow.png";
import downloadIcon from "./img/downloadIcon.png";
import { SpinnerGroup } from "./Utils/SpinnerGroup";
import { renameDbxItem } from "./networkFunctions";

const MAX_IMG = 5;
export default function Gallery({
   selectedImages,
   setSelectedImages,
   folderName,
   cols,
   width,
   subFolder,
   allowRename,
}) {
   const { loadedImages, setLoadedImages, hasMore, loadingList, loadingMore, loadMore, error, refresh } =
      useDropboxImages(folderName, subFolder);

   const [fullImages, setFullImages] = useState({}); // path -> url
   const [vollbild, setVollbild] = useState();
   const [edit, setEdit] = useState();
   const [loading, setLoading] = useState();
   // Fetch (or reuse cached) link for a given index, and warm the browser cache.

   if (loadingList)
      return (
         <div
            style={{
               position: "absolute",
               width: "100vw",
               display: "flex",
               justifyContent: "center",
               alignItems: "center",
               background: "#fffc",
               height: "calc(100% - 60px)",
               overflow: "hidden",
               pointerEvents: "none",
            }}
         >
            <SpinnerGroup></SpinnerGroup>
         </div>
      );
   if (error)
      return (
         <p style={{ position: "relative", color: "#fff", background: "#000b" }}>
            Fehler beim Laden der Bilder... {JSON.stringify(error)}
         </p>
      );

   return (
      <div
         style={{
            width: width + "%",
            height: "100%",
            overflow: "auto",
         }}
      >
         <>
            <div style={{ margin: 8, display: "grid", gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: 10 }}>
               {loadedImages.map((img, index) => {
                  return (
                     <div style={{ position: "relative" }}>
                        {setSelectedImages && (
                           <div style={{ position: "absolute", margin: 10 }}>
                              {selectedImages[img.path] ? (
                                 <Button
                                    onClick={() => {
                                       const newSelected = structuredClone(selectedImages);
                                       delete newSelected[img.path];

                                       setSelectedImages(newSelected);
                                    }}
                                    variant="warning"
                                    style={{ width: 60, aspectRatio: 1 }}
                                 ></Button>
                              ) : (
                                 <Button
                                    variant="outline-dark"
                                    onClick={() => {
                                       console.log(img);

                                       setSelectedImages((prev) => ({ ...prev, [img.path]: img }));
                                    }}
                                    style={{ width: 60, aspectRatio: 1 }}
                                 ></Button>
                              )}
                           </div>
                        )}
                        <img
                           key={img.path}
                           src={img.thumbnail || "placeholder.png"}
                           alt={img.name}
                           loading="lazy"
                           //  width={256}
                           style={{ width: "100%", /* cursor: "pointer", */ borderRadius: 4 }}
                        />
                        <div
                           style={{
                              position: "absolute",
                              zIndex: 1,
                              bottom: 20,
                              right: 20,
                              background: "#0004",
                              borderRadius: "10px",
                              // borderRadius: "20px 20px 0 0",
                              // borderRadius: "10px 0 0 10px",
                              overflow: "hidden",
                           }}
                        >
                           <Button
                              variant="outline-light"
                              onClick={() => {
                                 setVollbild(img);
                              }}
                           >
                              Vollbild
                           </Button>
                        </div>

                        {vollbild && (
                           <div style={{ position: "fixed", zIndex: 100, cursor: "pointer", top: "0", left: "0", width: "100vw", height: "100vh" }}>
                              <img
                                 onClick={() => {
                                    setVollbild();
                                 }}
                                 key={vollbild.path}
                                 src={vollbild.thumbnail || "placeholder.png"}
                                 alt={vollbild.name}
                                 loading="lazy"
                                 //  width={256}
                                 style={{ width: "100%", /* cursor: "pointer", */ borderRadius: 4 }}
                              />
                           </div>
                        )}
                        <div
                           style={{
                              position: "absolute",
                              zIndex: 1,
                              bottom: 20,
                              left: 0,
                              // left: "calc(50% - 200px)",
                              // width: "400px",
                              boxShadow: "0 0 10px #0004",
                              borderRadius: "0px 10px 10px 0",
                              // borderRadius: "20px 20px 0 0",
                              // borderRadius: "10px 0 0 10px",
                              overflow: "hidden",
                           }}
                        >
                           <>
                              <input
                                 disabled={!allowRename}
                                 value={edit?.[img.name] ? edit?.[img.name]?.newName : img.name.replace(".jpg", "")}
                                 onFocus={() => {
                                    setEdit((prev) => ({
                                       ...prev,
                                       [img.name]: { ...img, newName: img.name.replace(".jpg", "") },
                                    }));
                                 }}
                                 onChange={(e) => {
                                    try {
                                       const newEdit = structuredClone(edit);
                                       newEdit[img.name].newName = e.target.value;
                                       setEdit(newEdit);
                                    } catch (error) {
                                       console.log(error);
                                    }
                                 }}
                                 style={{
                                    padding: "5px 20px",
                                    background: "#fffd",
                                    color: "#000",
                                    borderRadius: 0,
                                    outline: "none",
                                    border: "none",
                                    textAlign: "center",
                                    ...(allowRename
                                       ? { background: "#fffd", color: "#000", fontWeight: 500 }
                                       : { background: "#0009", color: "#fff" }),
                                 }}
                              />
                              {edit?.[img.name] && edit?.[img.name].name !== edit?.[img.name].newName + ".jpg" && (
                                 <button
                                    disabled={loading}
                                    onClick={async () => {
                                       if (edit?.[img.name].name !== edit?.[img.name].newName + ".jpg") {
                                          console.log(edit);

                                          setLoading("loading");
                                          await renameDbxItem(
                                             edit?.[img.name].path,
                                             edit?.[img.name].path.replace(
                                                edit?.[img.name].name.toLowerCase(),
                                                edit?.[img.name].newName + ".jpg",
                                             ),
                                          );
                                          let updatedImages = structuredClone(loadedImages);
                                          updatedImages[index].name = edit?.[img.name].newName + ".jpg";
                                          updatedImages[index].path = edit?.[img.name].path.replace(
                                             edit?.[img.name].name.toLowerCase(),
                                             (edit?.[img.name].newName + ".jpg").toLowerCase(),
                                          );
                                          console.log(updatedImages[index]);

                                          setLoadedImages(updatedImages);
                                          setLoading("");
                                       }
                                       const newEdit = structuredClone(edit);
                                       delete newEdit[img.name];
                                       setEdit(newEdit);
                                    }}
                                    style={{
                                       borderRadius: "0",
                                       padding: "5px 20px",
                                       background: "#000",
                                       color: "#fff",
                                       // width: "100%",
                                       border: "none",
                                    }}
                                 >
                                    {loading === "loading" ? <SpinnerGroup></SpinnerGroup> : "Speichern"}
                                 </button>
                              )}
                           </>
                        </div>
                     </div>
                  );
               })}
            </div>
            <div style={{ position: "fixed", bottom: 10, width: "100%", padding: 20 }}>
               <button style={{ border: "none", background: "#0007", padding: "4px 10px" }} onClick={refresh}>
                  Cache leeren
               </button>
               <ReloadMore loadMore={loadMore} loadingMore={loadingMore} hasMore={hasMore} />
            </div>
         </>
      </div>
   );
}

function ReloadMore({ loadMore, loadingMore, hasMore }) {
   return (
      <>
         {hasMore && (
            <div style={{ display: "flex", margin: 10, justifyContent: "center" }}>
               <button
                  style={{
                     background: "#ffa",
                     color: "#990",
                     fontWeight: 600,
                     border: "solid 2px #990",
                     padding: "10px 20px",
                     borderRadius: 8,
                  }}
                  variant="outline-dark"
                  onClick={loadMore}
                  disabled={loadingMore}
               >
                  {loadingMore ? <SpinnerGroup /> : "weitere Bilder laden"}
               </button>
            </div>
         )}
      </>
   );
}
